export default "__VITE_ASSET__7bf1bacb__"